import React from "react";
import { MenuItem, Select, FormControl, Box, Typography } from "@mui/material";
import { dropDownProps } from "../lead-view-details-view-attachment-info/lead-view-details-view-attachment-info.props";

const SelectTemplateOption: React.FC<dropDownProps> = ({
  selectedOption,
  handleChange,
  disabled = false,
  options = [],
  placeholder = "Compose Email",
}) => {
  return (
      <FormControl fullWidth className="upload-dropdown" sx={{ width: "190px" }}>
      <Select
        displayEmpty
        value={selectedOption}
        onChange={handleChange}
        disabled={disabled}
        renderValue={(selectedVal) => {
          if (!selectedVal) {
            return <span className="placeholder">{placeholder}</span>;
          }
          const selected = options?.find((opt) => opt?.value === selectedVal);
          return selected?.label || "";
        }}
        
              
      >
        {options.map((option) => (
          <MenuItem key={option?.value} value={option?.value}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

              <Typography className="option-text">{option.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectTemplateOption;
